import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareSquare } from '@fortawesome/free-solid-svg-icons'

function Share() {

  const shareData = {
    title: 'Corona DK',
    text: 'Corona i Danmark med data fra Statens Serum Institut',
    url: 'https://coronadk.netlify.app',
  };

  if (navigator.share) {
    return (
      <div style={{ margin: 100 }} >
        <p>Del med dine venner</p>
        <FontAwesomeIcon icon={faShareSquare} size={'2x'} onClick={() => navigator.share(shareData)} />
      </div>
    );
  }
  return (
    <div style={{ margin: 100 }} >
      <p>Del med dine venner</p>
      <a href="https://coronadk.netlify.app">https://coronadk.netlify.app</a>
    </div>
  );
}

export default Share;